import { React, DomeComponent, DomeManipulator } from "@lexriver/dome";
import { Topbar } from "./Topbar";
import css from './MainContent.m.scss'
import { GlobalState } from "../GlobalState";
import { SwipeEvent } from "../SwipeEvent";
import { GlobalLeftSidebar } from "../GlobalLeftSidebar";
import { LoadingSpinnerForPage } from "./LoadingSpinnerForPage";

const filename = 'MainContent'

interface Attrs{

}

export class MainContent extends DomeComponent<Attrs>{
    protected refMainContentContainer!:HTMLDivElement
    protected refPageContent!:HTMLDivElement
    render(){
        return (
            <div ref={ref => this.refMainContentContainer = ref} class={css.mainContentContainer}>
                <div class={css.pageContent} ref={ref => this.refPageContent = ref}>
                    <LoadingSpinnerForPage />
                </div>
            </div>
        )
        
    }

    afterRender(){
        this.subscribeToPageChangeEvent()
    }


    protected async closeLeftSidebarAsync(){
        // console.log('closeLeftSidebar')
        await GlobalLeftSidebar.hideAsync()
    }


    protected subscribeToPageChangeEvent(){
        GlobalState.eventPageChange.subscribe(async (url:string, pageContent:HTMLElement) => {
            document.querySelector('.seo-body')?.remove() 
            await DomeManipulator.removeAllChildrenAsync(this.refPageContent)
            //#region animation
            const divAnimation = <div class={css.whiteOverlay} />
            document.body.appendChild(divAnimation)
            //requestAnimationFrame(() => {
            setTimeout(() => {
                divAnimation.style.background = 'transparent'
                setTimeout(() => {
                    divAnimation.remove()
                }, 800)
            }, 5)
            //})
            //#endregion animation
            
            try {
                this.refPageContent.appendChild(pageContent)
                //this.zoomToContent()
            } catch (x) {
                console.error(filename, 'unable to change page, pageContent=', pageContent, 'url=', url)
                throw x
            }
    
        })
    }

    // protected zoomToContent(){
    //     //(document.querySelector('meta[name="viewport"]') as HTMLMetaElement).content = "width=device-width, initial-scale=0.3, maximum-scale=3, minimum-scale=0.3"
    //     (document.querySelector('meta[name="viewport"]') as HTMLMetaElement).content = "width=device-width, initial-scale=1"
    // }

    

}